import styles from './index.less';
import { amountList } from '../../config';
import { Input } from 'antd-mobile';
import { FC, useEffect, useState } from 'react';

interface PreStoreProps {
  onChange: (value: number) => void;
}
const PreStore: FC<PreStoreProps> = ({ onChange }) => {
  const [amountValue, setAmountValue] = useState<any>();

  useEffect(() => {
    onChange(amountValue);
  }, [amountValue]);
  const handleQuickAmount = (value: number) => {
    setAmountValue(value);
  };

  const handleAmountChange = (value: any) => {
    setAmountValue(value);
  };
  return (
    <div className={styles.container}>
      <div className={styles.title}>预存金额</div>
      <div className={styles.content}>
        <div className={styles.amount}>
          {amountList.map((item) => (
            <div onClick={() => handleQuickAmount(item.value)} key={item.value}>
              {item.label}
            </div>
          ))}
        </div>
        <div>
          <span className={styles.symbol}>￥ </span>
          <Input
            type={'number'}
            value={amountValue}
            onChange={handleAmountChange}
            className={styles.input}
            placeholder={'请输入自定义金额'}
          />
        </div>
      </div>
      <div className={styles.tips}>
        <p>充值说明</p>
        <p> 1、本次充值仅限在平台上消费，无法跨地区跨站点使用。</p>
        <p> 2、若遇到充值未到账，请联系专属管家。</p>
      </div>
    </div>
  );
};

export default PreStore;
